import React from 'react';
import axios from '../../../../axios-config.js';

const InputField = ({ title, value, onChange, placeholder, hint }) => {
  return (
    <label className="CreateCompanyInput modernField">
      <div className="input-title">{title}</div>
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
      {hint ? <div className="input-hint">{hint}</div> : null}
    </label>
  );
};

class CompanyCreator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      website: '',
      slug: '',
      isSubmitting: false,
      error: null,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    const state = this.state;

    if (!state.name || !state.name.trim()) {
      this.setState({ error: 'Company name cannot be empty.' });
      return;
    }

    if (!state.slug || !state.slug.trim()) {
      this.setState({ error: 'Company slug cannot be empty.' });
      return;
    }

    this.setState({ isSubmitting: true, error: null });

    axios.post('/company', {
      name: state.name,
      website: state.website,
      slug: state.slug,
    })
    .then(() => {
      this.setState({ isSubmitting: false });
      this.props.back();
    })
    .catch((error) => {
      this.setState({
        isSubmitting: false,
        error: error?.response?.data?.message || 'An error occurred while creating the company.',
      });
    });
  }

  render() {
    return (
      <div className="CompanyEditorModal">
        <div className="CompanyEditorHeader">
          <div className="CompanyEditorTitle">Create Company</div>
          <div className="CompanyEditorSubtitle">Create a new company tenant and configure its URL/metadata.</div>
        </div>

        <div className="CompanyEditorSection">
          {this.state.error ? (
            <div className="PermissionLoadState error" style={{ marginBottom: '8px' }}>{this.state.error}</div>
          ) : null}

          <div className="CompanyEditorFormGrid">
            <InputField
              title="Company Name"
              placeholder="XYZ Limited"
              value={this.state.name}
              onChange={(name) => this.setState({ name })}
              hint="Required"
            />
            <InputField
              title="Website"
              placeholder="https://example.com"
              value={this.state.website}
              onChange={(website) => this.setState({ website })}
            />
            <InputField
              title="URL Slug"
              placeholder="xyz-limited"
              value={this.state.slug}
              onChange={(slug) => this.setState({ slug })}
              hint="Used in company URL path: /c/[slug]"
            />
          </div>

          <div className="CompanyEditorFormActions">
            <button type="button" className="CompanyEditorSecondaryButton" onClick={this.props.back}>Cancel</button>
            <button
              type="button"
              className="CompanyEditorPrimaryButton"
              onClick={this.handleSubmit}
              disabled={this.state.isSubmitting}
            >
              {this.state.isSubmitting ? 'Creating…' : 'Create Company'}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default CompanyCreator;
